import { call, select } from 'redux-saga/effects';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { isLoggedIn } from 'redux/saga/selectors';
import { userProfile, userInactivePermissions } from 'redux/saga/entities/bound';

// redirects users depending on eligibility for winback offers
export function* checkWinbackOfferPermissionSaga(client, replaceState, isAllowedTo, notAllowedTo) {
  if (yield select(isLoggedIn)) {
    const profile = yield call(fetchEntityIfNeeded, userProfile, [client]);
    const permissions = yield call(fetchEntityIfNeeded, userInactivePermissions, [client, profile.id]);
    if (permissions.disallow_winback_offers) {
      return notAllowedTo && (yield call(replaceState, notAllowedTo));
    }
    return isAllowedTo && (yield call(replaceState, isAllowedTo));
  }
}
